import { render, staticRenderFns } from "./tables.vue?vue&type=template&id=4ad106dc&scoped=true&"
import script from "./tables.vue?vue&type=script&lang=ts&"
export * from "./tables.vue?vue&type=script&lang=ts&"
import style0 from "./tables.vue?vue&type=style&index=0&id=4ad106dc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad106dc",
  null
  
)

export default component.exports